/**
 * <s-cookie-preferences> reopens Shopify's cookie banner preferences so visitors
 * can change or withdraw their consent. A footer button targets it with
 * `commandfor` + `command="--show-cookie-preferences"`. When the banner is not
 * available (for example outside consent regions), it falls back to the URL in
 * `data-fallback-url`, normally the cookie policy page.
 */
class SCookiePreferences extends HTMLElement {
  connectedCallback() {
    this.handleCommand = (event) => {
      if (event.command !== '--show-cookie-preferences') return;
      this.showPreferences();
    };
    this.addEventListener('command', this.handleCommand);
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.handleCommand);
  }

  openBanner() {
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      banner.showPreferences();
      return true;
    }
    return false;
  }

  showPreferences() {
    if (this.openBanner()) return;

    const loadFeatures = window.Shopify && window.Shopify.loadFeatures;
    if (typeof loadFeatures === 'function') {
      loadFeatures.call(window.Shopify, [{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && this.openBanner()) return;
        this.fallback();
      });
      return;
    }

    this.fallback();
  }

  fallback() {
    const url = this.dataset.fallbackUrl;
    if (url) window.location.assign(url);
  }
}

if (!customElements.get('s-cookie-preferences')) {
  customElements.define('s-cookie-preferences', SCookiePreferences);
}
